var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClass ? `${_vm.customClass}` : 'block'},[_vm._t("operation"),_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[20, 40, 60, 80],"page-size":20,"layout":"total, prev, pager, next,sizes","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }